import React, { useEffect, useState } from 'react'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
 import moment from 'moment'

function DateRangeSelector ({
  formData,
  setFormData,
  setDateRangeOpen,
  dateRangeOpen,
  handleOnchangeDate,
  endDate
}) {
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ])
  const [endDateSelector, setEndDateSelector] = useState()
  useEffect(() => {
    setEndDateSelector(moment(formData.departureDate).format('YYYY-MM-DD'))
  }, [formData.departureDate])
  console.log('endDate', formData.departureDate)
  const isValidDate = (date) => {
    const d = new Date(date);
    return d instanceof Date && !isNaN(d);
  };
  
  return (
    <div
      className='DateRange-Main'
      style={{ display: dateRangeOpen ? 'flex' : 'none' }}
    >
      {dateRangeOpen && (
        <div
          onClick={() => setDateRangeOpen(false)}
          className='GuestCounter-center'
        ></div>
      )}
      <div className='section-DateRange'>
        {dateRangeOpen && (
          <div className='DateRange-Date'>
            <DateRange
              editableDateInputs={true}
              onChange={item => {
                setDateRange([item.selection])
                handleOnchangeDate(item)
                // Automatically close date picker after selection if both dates are selected
                if (item.selection.startDate && item.selection.endDate) {
                  setDateRangeOpen(false)
                }
              }}
              onContextMenu={e => {
                e.preventDefault() 
                setDateRangeOpen(false) // Close the date picker on right-click
              }}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              minDate={isValidDate(endDateSelector) ? new Date(endDateSelector) : undefined}
              // maxDate={new Date(moment(formData.EndDate).format('YYYY MM DD'))}
              months={1}
              direction='horizontal'
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DateRangeSelector
